















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import deck from '@/store/modules/deck';

@Component({ components: {} })
export default class OrgChart extends Vue {
  @Prop() slide!: any;
  @Prop() subSlide!: any;
  @Prop() dark!: boolean;
  @Prop({ default: false }) editMode!: boolean;
  @Prop({ default: false }) showToggle!: boolean;
  @Prop() mode!: string;

  private chart: any = null;
  private chartId: string = `chart-${Math.random()
    .toString(36)
    .substring(2, 15)}`;

  private chartData: string = JSON.stringify(this.subSlide.chartData);

  // Modal state
  private showEditModal: boolean = false;
  private editingNode: any = {
    id: null,
    pid: null,
    name: '',
    part: '100%',
    isPhysicalPerson: false,
    color: 'corePurple',
    additionalInfo: '',
    tags: [],
  };
  private additionalOwners: any[] = [];

  private showLinkModal: boolean = false;
  private availableNodes: any[] = [];
  private targetNode: any = null;
  private linkPart: string = '100%';

  // Tooltip state
  private tooltip: { show: boolean; x: number; y: number; text: string } = {
    show: false,
    x: 0,
    y: 0,
    text: '',
  };

  mounted() {
    this.setupTemplates();
    this.renderOrgChart();
    this.applyTagsToAllNodes();

    this.chart.onInit(() => {
      this.chart.fit();
    });

    this.chart.draw();

    setTimeout(() => {
      this.chart.fit();
    }, 50);

    // Lägg till tooltip-hantering
    this.setupTooltipHandling();
  }

  get isPrint() {
    if (
        !this.$router ||
        !this.$router.currentRoute ||
        !this.$router.currentRoute.name
    ) {
        return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }

  @Watch('subSlide', { deep: true })
  onChartDataChange() {
    if (this.chartData !== JSON.stringify(this.subSlide.chartData)) {
      this.chartData = JSON.stringify(this.subSlide.chartData);
      this.renderOrgChart();
      this.applyTagsToAllNodes();
      this.chart.draw();
    } else {
      this.applyTagsToAllNodes();
    }

    setTimeout(() => {
      this.chart.fit();
    }, 50);
  }

  get isShared() {
    const route = this.$router.currentRoute.name;
    if (!route) {
      return false;
    }
    return route.startsWith('presentation-shared');
  }

  private setupTooltipHandling(): void {
    const container = document.getElementById(this.chartId);
    if (!container) {
      return;
    }

    // Hantera mouseenter för att visa tooltip
    container.addEventListener(
      'mouseenter',
      (e: Event) => {
        // Visa inte tooltip om mode är "preview"
        if (this.mode === 'preview') {
          return;
        }

        const target = e.target as HTMLElement;
        if (target && target.classList.contains('tooltip-trigger')) {
          const additionalInfo = target.getAttribute('data-additional-info');
          if (additionalInfo && additionalInfo.trim()) {
            this.showTooltip(e as MouseEvent, additionalInfo);
          }
        }
      },
      true,
    );

    // Hantera mouseleave för att dölja tooltip
    container.addEventListener(
      'mouseleave',
      () => {
        this.hideTooltip();
      },
      true,
    );

    // Hantera mousemove för att uppdatera tooltip-position
    container.addEventListener(
      'mousemove',
      (e: Event) => {
        if (this.tooltip.show) {
          this.updateTooltipPosition(e as MouseEvent);
        }
      },
      true,
    );
  }

  private showTooltip(event: MouseEvent, text: string): void {
    this.tooltip.text = text;
    this.tooltip.show = true;
    this.updateTooltipPosition(event);
  }

  private hideTooltip(): void {
    this.tooltip.show = false;
  }

  private updateTooltipPosition(event: MouseEvent): void {
    const container = document.getElementById(this.chartId);
    if (!container) {
      return;
    }

    const rect = container.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;

    // Positionera tooltip relativt till chart-containern
    this.tooltip.x = offsetX + 10;
    this.tooltip.y = offsetY - 30;
  }

  private toggleEditMode(): void {
    this.$emit('toggleEditMode');
  }

  private isTarget(id: any): boolean {
    const slink = this.chart.config.slinks.find((s: any) => s.to === id);
    return !!slink;
  }

  private getNode(id: any): any {
    const parent = this.chart.config.nodes.find(
      (n: any) => n.id === Number(id),
    );
    return parent;
  }

  private updateSlide() {
    if (this.showToggle) {
      return;
    }

    // Create a clean copy of nodes without circular references
    const cleanNodes = this.chart.config.nodes.map((node: any) => ({
      id: node.id,
      pid: node.pid,
      name: node.name,
      part: node.part,
      isPhysicalPerson: node.isPhysicalPerson,
      color: node.color,
      additionalInfo: node.additionalInfo,
      tags: node.tags ? [...node.tags] : [],
    }));

    const chartData = {
      nodes: cleanNodes,
      slinks: this.chart.config.slinks,
    };

    if (this.chartData === JSON.stringify(chartData)) {
      return;
    }

    this.subSlide.chartData = chartData;
    deck.updateSlide({
      slide: this.slide,
      index: deck.nav.currentSlide - 1,
    });
  }

  private getData() {
    if (!this.subSlide) {
      return {
        nodes: [],
        slinks: [],
      };
    }

    if (!this.subSlide.chartData) {
      this.subSlide.chartData = {
        nodes: [
          {
            id: 1,
            template: 'person_edit_top',
            name: 'Nytt företag',
            tags: ['kind_company_top'],
            part: '100%',
            isPhysicalPerson: false,
            color: 'brightPurple',
            additionalInfo: '',
          },
        ],
        slinks: [],
      };
    }

    return this.subSlide.chartData;
  }

  private renderOrgChart() {
    if (this.editMode) {
      this.renderEditableChart();
    } else {
      this.renderViewOnlyChart();
    }
  }

  private setupTemplates() {
    const Chart = (window as any).OrgChart;

    Chart.LAZY_LOADING = !this.isPrint;

    // console.log(Chart.templates);
    // console.log(Chart.slinkTemplates);

    Chart.slinkTemplates.mySlink = Object.assign(
      {},
      Chart.slinkTemplates.yellow,
    );
    Chart.slinkTemplates.mySlink.link =
      '<path stroke-linejoin="round" stroke="#00A4B3" stroke-width="2px" fill="none" d="{d}" />';
    Chart.slinkTemplates.mySlink.label =
      '<text fill="#00A4B3" text-anchor="middle" x="{x}" y="{y}">{val}</text>';

    // read-only template for company nodes
    Chart.templates.company_view = JSON.parse(
      JSON.stringify(Chart.templates.mila),
    );
    Chart.templates.company_view.defs = ``;
    Chart.templates.company_view.size = [200, 75];
    Chart.templates.company_view.link = `<path stroke-linejoin="round" stroke="#2B144D" stroke-width="2px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" />`;
    Chart.templates.company_view.link_field_0 = `<text text-anchor="middle" fill="black" data-width="290" x="25" y="0" style="font-size:16px; font-family: 'GT-regular', sans-serif;">{val}</text>`;
    Chart.templates.company_view.node = `<rect class="shape node" x="0" y="0" width="200" height="75" stroke="#2B144D" stroke-width="1"></rect>`;
    Chart.templates.company_view.field_0 = `<text class="title" x="100" y="37.5" text-anchor="middle" dominant-baseline="middle" fill="#FFFFFF" font-size="18px" font-family="'GT-regular', sans-serif" >{val}</text>`;
    Chart.templates.company_view.field_1 = `<rect class="tooltip-trigger" x="0" y="0" width="200" height="75" fill="transparent" data-additional-info="{val}"></rect>`;
    Chart.templates.company_view.plus = '';
    Chart.templates.company_view.minus = '';

    // read-only template for company top nodes
    Chart.templates.company_view_top = JSON.parse(
      JSON.stringify(Chart.templates.company_view),
    );

    // read-only template for person nodes
    Chart.templates.person_view = JSON.parse(
      JSON.stringify(Chart.templates.polina),
    );
    Chart.templates.person_view.size = [100, 100];
    Chart.templates.person_view.node = `<circle class="shape node" cx="50" cy="50" r="50" stroke="#2B144D" stroke-width="1"></circle>`;
    Chart.templates.person_view.field_0 = `<text class="title" x="50" y="50" text-anchor="middle" dominant-baseline="middle" fill="#000000" font-size="18px" font-family="'GT-regular', sans-serif" >{val}</text>`;
    Chart.templates.person_view.field_1 = `<circle class="tooltip-trigger" cx="50" cy="50" r="50" fill="transparent" data-additional-info="{val}"></circle>`;
    Chart.templates.person_view.plus = '';
    Chart.templates.person_view.minus = '';

    // read-only template for person top nodes
    Chart.templates.person_view_top = JSON.parse(
      JSON.stringify(Chart.templates.person_view),
    );

    // editable template for company nodes
    Chart.templates.company_edit = JSON.parse(
      JSON.stringify(Chart.templates.mila),
    );
    Chart.templates.company_edit.defs = ``;
    Chart.templates.company_edit.size = [200, 75];
    Chart.templates.company_edit.link = `<path stroke-linejoin="round" stroke="#2B144D" stroke-width="2px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" />`;
    Chart.templates.company_edit.link_field_0 = `<text text-anchor="middle" fill="black" data-width="290" x="25" y="0" style="font-size:16px; font-family: 'GT-regular', sans-serif;">{val}</text>`;
    Chart.templates.company_edit.node = `<rect class="shape node" x="0" y="0" width="200" height="75" stroke="#2B144D" stroke-width="1"></rect>
    <circle class="add-parent-btn" cx="100" cy="0" r="15" fill="#CCC4BD" stroke="#2B144D" stroke-width="1" style="cursor: pointer;" data-action="add-parent"></circle>
    <text x="100" y="2" text-anchor="middle" dominant-baseline="middle" fill="black" font-size="18px" font-weight="bold" style="pointer-events: none;">+</text>
    <circle class="add-child-btn" cx="100" cy="75" r="15" fill="#CCC4BD" stroke="#2B144D" stroke-width="1" style="cursor: pointer;" data-action="add-child"></circle>
    <text x="100" y="77" text-anchor="middle" dominant-baseline="middle" fill="black" font-size="18px" font-weight="bold" font-family="'GT-bold', sans-serif" style="pointer-events: none;">+</text>`;
    Chart.templates.company_edit.field_0 = `<text class="title" x="100" y="37.5" text-anchor="middle" dominant-baseline="middle" fill="#FFFFFF" font-size="18px" font-family="'GT-regular', sans-serif" >{val}</text>`;
    Chart.templates.company_edit.field_1 = `<rect class="tooltip-trigger" x="0" y="0" width="200" height="75" fill="transparent" data-additional-info="{val}"></rect>`;
    Chart.templates.company_edit.plus = '';
    Chart.templates.company_edit.minus = '';
    Chart.templates.company_edit.linkAdjuster.fromY = -15;
    Chart.templates.company_edit.linkAdjuster.toY = 15;

    // editable template for top company nodes
    Chart.templates.company_edit_top = JSON.parse(
      JSON.stringify(Chart.templates.company_edit),
    );

    // editable template for person nodes
    Chart.templates.person_edit = JSON.parse(
      JSON.stringify(Chart.templates.polina),
    );
    Chart.templates.person_edit.size = [100, 100];
    Chart.templates.person_edit.node = `<circle class="shape node" cx="50" cy="50" r="50" stroke="#2B144D" stroke-width="1"></circle>
    <circle class="add-child-btn" cx="50" cy="100" r="15" fill="#CCC4BD" stroke="#2B144D" stroke-width="1" style="cursor: pointer;" data-action="add-child"></circle>
    <text x="50" y="100" text-anchor="middle" dominant-baseline="middle" fill="black" font-size="18px" font-weight="bold" font-family="'GT-bold', sans-serif" style="pointer-events: none;">+</text>`;
    Chart.templates.person_edit.field_0 = `<text class="title" x="50" y="50" text-anchor="middle" dominant-baseline="middle" fill="#000000" font-size="18px" font-family="'GT-regular', sans-serif" >{val}</text>`;
    Chart.templates.person_edit.field_1 = `<circle class="tooltip-trigger" cx="50" cy="50" r="50" fill="transparent" data-additional-info="{val}"></circle>`;
    Chart.templates.person_edit.plus = '';
    Chart.templates.person_edit.minus = '';

    // editable template for top person nodes
    Chart.templates.person_edit_top = JSON.parse(
      JSON.stringify(Chart.templates.person_edit),
    );
  }

  private renderViewOnlyChart() {
    const Chart = (window as any).OrgChart;

    this.chart = new Chart(
      `#${this.chartId}`,
      Object.assign({}, this.getData(), {
        template: 'company_view',
        mouseScrool: Chart.none,
        enableSearch: false,
        scaleInitial: Chart.match.boundary,
        anim: { func: Chart.anim.outBack, duration: 50 },
        mouseWheel: false,
        mouseWheelZoom: false,
        zoom: false,
        drag: false,
        dragDrop: false,
        dragDropMenu: false,
        nodeBinding: {
          field_0: 'name',
          field_1: 'additionalInfo',
        },
        linkBinding: {
          link_field_0: 'part',
        },
        tags: {
          kind_company: {
            template: 'company_view',
          },
          kind_company_top: {
            template: 'company_view_top',
          },
          kind_person: {
            template: 'person_view',
          },
          kind_person_top: {
            template: 'person_view_top',
          },
        },
      }),
    );

    this.chart.on('click', (sender: any, args: any) => false);
    this.chart.on('dblclick', () => false);
  }

  private renderEditableChart() {
    const Chart = (window as any).OrgChart;

    const self = this;

    this.chart = new Chart(
      `#${this.chartId}`,
      Object.assign({}, this.getData(), {
        template: 'company_edit',
        mouseScrool: Chart.none,
        enableSearch: false,
        scaleInitial: Chart.match.boundary,
        anim: { func: Chart.anim.outBack, duration: 50 },
        mouseWheel: false,
        mouseWheelZoom: false,
        zoom: false,
        drag: false,
        dragDrop: false,
        dragDropMenu: false,
        enableDragDrop: true,
        nodeBinding: {
          field_0: 'name',
          // field_1: 'additionalInfo',
        },
        linkBinding: {
          link_field_0: 'part',
        },
        tags: {
          kind_company: {
            template: 'company_edit',
          },
          kind_company_top: {
            template: 'company_edit_top',
          },
          kind_person: {
            template: 'person_edit',
          },
          kind_person_top: {
            template: 'person_edit_top',
          },
        },
      }),
    );

    this.chart.onUpdated(() => {
      this.updateSlide();
    });

    this.chart.on('dblclick', () => false);

    this.chart.on('click', (sender: any, args: any) => {
      const target = args.event.target as HTMLElement;
      const node = args.node;

      if (!node || !target || !target.classList) {
        return false;
      }

      if (target.classList.contains('add-child-btn')) {
        this.addChildNode(node);
      } else if (target.classList.contains('add-parent-btn')) {
        if (node.pid) {
          this.openLinkModal(node);
        } else {
          this.addParentNode(node);
        }
      } else {
        // Hitta noden från chart.config.nodes för att få rätt data
        const chartNode = this.chart.config.nodes.find(
          (n: any) => n.id === node.id,
        );
        this.openEditModal(chartNode);
      }
      return false;
    });
  }

  private applyTagsToAllNodes(): void {
    this.chart.config.nodes.forEach((node: any) => {
      this.applyTagToNode(node);
    });
  }

  private applyTagToNode(node: any): void {
    if (!node) {
      return;
    }

    if (!node.tags) {
      node.tags = [];
    }

    if (node.isPhysicalPerson && !node.pid) {
      this.setNodeKind(node, 'kind_person_top');
    } else if (node.isPhysicalPerson) {
      this.setNodeKind(node, 'kind_person');
    } else if (!node.pid) {
      this.setNodeKind(node, 'kind_company_top');
    } else {
      this.setNodeKind(node, 'kind_company');
    }

    this.setNodeColor(node, node.color);
  }

  private setNodeColor(node: any, color: string): void {
    if (!node.tags.includes(color)) {
      node.tags = node.tags.filter((tag: string) => !COLOR_TAGS.has(tag));
      node.tags.push(color);
    }
  }

  private setNodeKind(node: any, kind: string): void {
    if (!node.tags.includes(kind)) {
      node.tags = node.tags.filter((tag: string) => !tag.startsWith('kind_'));
      node.tags.push(kind);
    }
  }

  private addChildNode(parent: any): void {
    const newNode = {
      id: Math.max(...this.chart.config.nodes.map((n: any) => n.id)) + 1,
      pid: parent.id,
      name: `Nytt företag`,
      part: '100%',
      isPhysicalPerson: false,
      color: 'corePurple',
      additionalInfo: '',
      tags: ['kind_company', 'corePurple'],
    };

    this.chart.add(newNode);
    this.applyTagToNode(newNode);
    this.updateSlide();

    // Öppna editForm-modalen för den nya noden
    setTimeout(() => {
      this.openEditModal(newNode);
    }, 100);
  }

  private addParentNode(node: any): void {
    const newNode = {
      id: Math.max(...this.chart.config.nodes.map((n: any) => n.id)) + 1,
      pid: null,
      name: `Nytt företag`,
      part: '100%',
      isPhysicalPerson: false,
      color: 'corePurple',
      additionalInfo: '',
      tags: ['kind_company_top corePurple'],
    };

    this.chart.add(newNode);

    node = this.chart.get(node.id);

    node.pid = newNode.id;
    this.chart.update(node);
    this.applyTagToNode(node);
    this.updateSlide();

    // Öppna editForm-modalen för den nya föräldernoden
    setTimeout(() => {
      this.openEditModal(newNode);
    }, 100);
  }

  // Modal methods
  private openEditModal(node: any): void {
    // Skapa en komplett kopia av nodens data med standardvärden för saknade fält
    this.editingNode = {
      id: node.id,
      pid: node.pid,
      name: node.name || '',
      part: node.part || '100%',
      isPhysicalPerson: node.isPhysicalPerson || false,
      color: node.color || 'corePurple',
      additionalInfo: node.additionalInfo || '',
      tags: node.tags ? [...node.tags] : [],
    };
    this.additionalOwners = this.getAdditionalOwners(this.editingNode.id);
    this.showEditModal = true;
  }

  private closeEditModal(): void {
    this.showEditModal = false;
    // Återställ editingNode till initiala värden
    this.editingNode = {
      id: null,
      pid: null,
      name: '',
      part: '100%',
      isPhysicalPerson: false,
      color: 'corePurple',
      additionalInfo: '',
      tags: [],
    };
  }

  private deleteNode(): void {
    if (!this.editingNode || !this.editingNode.id) {
      return;
    }
    const id = this.editingNode.id;
    this.closeEditModal();
    this.chart.config.slinks = this.chart.config.slinks.filter(
      (link: any) => link.to !== id,
    );
    this.chart.remove(id);
    this.updateSlide();
  }

  private saveNode(): void {
    if (!this.editingNode || !this.editingNode.id) {
      return;
    }

    // Hitta den ursprungliga noden i chartet
    const originalNode = this.chart.config.nodes.find(
      (n: any) => n.id === this.editingNode.id,
    );
    if (originalNode) {
      // Uppdatera noden med de nya värdena
      Object.assign(originalNode, {
        name: this.editingNode.name,
        part: this.editingNode.part,
        isPhysicalPerson: this.editingNode.isPhysicalPerson,
        color: this.editingNode.color,
        additionalInfo: this.editingNode.additionalInfo,
      });

      // Tillämpa tags baserat på de nya värdena
      this.applyTagToNode(originalNode);

      // Uppdatera chartet
      this.chart.update(originalNode);
    }

    // Update additional owner parts in slinks
    this.updateAdditionalOwnerParts();

    this.updateSlide();
    this.closeEditModal();
  }

  private updateAdditionalOwnerParts(): void {
    if (!this.chart || !this.chart.config || !this.chart.config.slinks) {
      return;
    }

    // Update each slink with the new part value
    this.additionalOwners.forEach((owner: any) => {
      const slink = this.chart.config.slinks.find(
        (link: any) =>
          link.to === this.editingNode.id && link.from === owner.id,
      );

      if (slink) {
        slink.label = owner.part;
      }
    });
  }

  private openLinkModal(targetNode: any): void {
    this.targetNode = this.getNode(targetNode.id);
    this.availableNodes = this.chart.config.nodes.filter(
      (node: any) => node.id !== targetNode.id && node.pid !== targetNode.id,
    );
    this.showLinkModal = true;
  }

  private closeLinkModal(): void {
    this.showLinkModal = false;
    this.availableNodes = [];
    this.targetNode = null;
  }

  private createLink(sourceNode: any): void {
    if (!this.targetNode || !sourceNode) {
      return;
    }

    // Ensure slinks array exists
    if (!this.chart.config.slinks) {
      this.chart.config.slinks = [];
    }

    const link = {
      id:
        this.chart.config.slinks.length > 0
          ? Math.max(...this.chart.config.slinks.map((s: any) => s.id)) + 1
          : 1,
      from: sourceNode.id,
      to: this.targetNode.id,
      label: this.linkPart || '100%',
      template: 'mySlink',
    };

    this.chart.config.slinks.push(link);
    this.closeLinkModal();
    this.updateSlide();
  }

  private createNewParentNode(): void {
    if (!this.targetNode) {
      return;
    }

    const newNode = {
      id: Math.max(...this.chart.config.nodes.map((n: any) => n.id)) + 1,
      pid: null,
      name: `Nytt företag`,
      part: '100%',
      isPhysicalPerson: false,
      color: 'corePurple',
      additionalInfo: '',
      tags: ['kind_company_top', 'corePurple'],
    };

    const link = {
      id:
        this.chart.config.slinks.length > 0
          ? Math.max(...this.chart.config.slinks.map((s: any) => s.id)) + 1
          : 1,
      from: newNode.id,
      to: this.targetNode.id,
      label: this.linkPart || '100%',
      template: 'mySlink',
    };

    this.chart.config.slinks.push(link);

    this.chart.add(newNode);
    this.applyTagToNode(newNode);

    this.closeLinkModal();
    this.updateSlide();
  }

  private getAdditionalOwners(nodeId: string): any[] {
    if (!this.chart || !this.chart.config || !this.chart.config.slinks) {
      return [];
    }

    return this.chart.config.slinks
      .filter((link: any) => link.to === nodeId)
      .map((link: any) => {
        const sourceNode = this.chart.config.nodes.find(
          (node: any) => node.id === link.from,
        );
        return {
          id: sourceNode.id || link.from,
          name: sourceNode.name || 'Unknown',
          part: link.label || '100%',
        };
      });
  }

  private removeParent(targetNodeId: string): void {
    const node = this.getNode(targetNodeId);
    node.pid = null;
    this.chart.update(node);
    this.closeEditModal();
    this.updateSlide();
  }

  private removeOwnerLink(targetNodeId: string, ownerId: string): void {
    if (!this.chart || !this.chart.config || !this.chart.config.slinks) {
      return;
    }

    const linkIndex = this.chart.config.slinks.findIndex(
      (link: any) => link.to === targetNodeId && link.from === ownerId,
    );

    this.closeEditModal();

    if (linkIndex !== -1) {
      this.chart.config.slinks.splice(linkIndex, 1);
      this.updateSlide();
    }
  }
}

const COLOR_TAGS = new Set([
  'corePurple',
  'teal',
  'coral',
  'yellow',
  'brightPurple',
  'warmgrey',
]);
